/**
 * TeamSection - Modal functionality for team member profiles
 * Modals are generated dynamically via JS
 */
(function () {
    if (window.teamSectionInitialized) return;
    window.teamSectionInitialized = true;

    // SVG Icons
    const bbSymbolSmall = `<svg class="h-3 w-3 text-brand" width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.14966 -9.76725e-08H0C1.24324 -0.000224227 2.44115 0.471051 3.35611 1.32034C4.27108 2.16964 4.83625 3.3349 4.93953 4.585C5.0428 5.83509 4.67664 7.07869 3.91366 8.06911C3.15069 9.05954 2.04664 9.72443 0.820527 9.9319V9.99924H7.14966C8.44552 9.97122 9.67895 9.43213 10.5856 8.49749C11.4923 7.56286 12 6.30707 12 4.99924C12 3.6914 11.4923 2.4356 10.5856 1.50097C9.67895 0.566344 8.44552 0.0280176 7.14966 -9.76725e-08Z" fill="currentColor"/></svg>`;

    const closeIcon = `<svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    // DNA Pattern V2 SVG (794x480) - fill #3c3333 matching Astro
    const dnaPatternV2 = `<svg
  class={className}
  fill={fill}
  viewBox="0 0 794 480"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M5.19051 480H0.471574V384H5.19051V480Z" fill="currentColor"></path>
  <path
    d="M4.98107 384.001H0.697915V288.001H4.98107V384.001Z"
    fill="currentColor"></path>
  <path d="M5.67766 192.004H0V96.0038H5.67766V192.004Z" fill="currentColor"
  ></path>
  <path d="M3.33792 95.9999H2.33901V0H3.33792V95.9999Z" fill="currentColor"
  ></path>
  <path
    d="M24.2107 384.001H22.8996V288.001H24.2107V384.001Z"
    fill="currentColor"></path>
  <path
    d="M24.2729 287.997H22.8619V191.998H24.2729V287.997Z"
    fill="currentColor"></path>
  <path
    d="M25.6533 192.004H21.4822V96.0038H25.6533V192.004Z"
    fill="currentColor"></path>
  <path d="M25.1645 95.9999H21.9646V0H25.1645V95.9999Z" fill="currentColor"
  ></path>
  <path d="M44.7496 480H43.8025V384H44.7496V480Z" fill="currentColor"></path>
  <path
    d="M47.2763 384.001H41.2749V288.001H47.2763V384.001Z"
    fill="currentColor"></path>
  <path
    d="M47.8249 287.997H40.7278V191.998H47.8249V287.997Z"
    fill="currentColor"></path>
  <path
    d="M46.9021 192.004H41.6602V96.0038H46.9021V192.004Z"
    fill="currentColor"></path>
  <path d="M46.6765 95.9999H41.8704V0H46.6765V95.9999Z" fill="currentColor"
  ></path>
  <path d="M67.8066 480H62.1912V384H67.8066V480Z" fill="currentColor"></path>
  <path
    d="M66.7005 287.997H63.3014V191.998H66.7005V287.997Z"
    fill="currentColor"></path>
  <path d="M70.556 192.004H59.4372V96.0038H70.556V192.004Z" fill="currentColor"
  ></path>
  <path d="M69.8506 95.9999H60.1513V0H69.8506V95.9999Z" fill="currentColor"
  ></path>
  <path d="M88.1642 480H83.2585V384H88.1642V480Z" fill="currentColor"></path>
  <path
    d="M88.4882 384.001H82.9351V288.001H88.4882V384.001Z"
    fill="currentColor"></path>
  <path
    d="M88.0418 287.997H83.3851V191.998H88.0418V287.997Z"
    fill="currentColor"></path>
  <path
    d="M87.9944 192.004H83.4498V96.0038H87.9944V192.004Z"
    fill="currentColor"></path>
  <path d="M87.9873 95.9999H83.4552V0H87.9873V95.9999Z" fill="currentColor"
  ></path>
  <path d="M108.701 480H104.194V384H108.701V480Z" fill="currentColor"></path>
  <path
    d="M108.872 287.997H103.992V191.998H108.872V287.997Z"
    fill="currentColor"></path>
  <path
    d="M107.675 192.004H105.185V96.0038H107.675V192.004Z"
    fill="currentColor"></path>
  <path d="M107.677 95.9999H105.199V0H107.677V95.9999Z" fill="currentColor"
  ></path>
  <path d="M129.378 480H124.946V384H129.378V480Z" fill="currentColor"></path>
  <path
    d="M127.874 287.997H126.438V191.998H127.874V287.997Z"
    fill="currentColor"></path>
  <path
    d="M129.775 192.004H124.533V96.0038H129.775V192.004Z"
    fill="currentColor"></path>
  <path d="M150.054 480H145.684V384H150.054V480Z" fill="currentColor"></path>
  <path
    d="M151.594 384.001H144.186V288.001H151.594V384.001Z"
    fill="currentColor"></path>
  <path
    d="M151.032 287.997H144.719V191.998H151.032V287.997Z"
    fill="currentColor"></path>
  <path
    d="M150.396 192.004H145.366V96.0038H150.396V192.004Z"
    fill="currentColor"></path>
  <path d="M152.074 95.9999H143.682V0H152.074V95.9999Z" fill="currentColor"
  ></path>
  <path d="M169.627 480H167.56V384H169.627V480Z" fill="currentColor"></path>
  <path
    d="M172.135 384.001H165.075V288.001H172.135V384.001Z"
    fill="currentColor"></path>
  <path
    d="M168.905 287.997H168.285V191.998H168.905V287.997Z"
    fill="currentColor"></path>
  <path
    d="M168.905 192.004H168.285V96.0038H168.905V192.004Z"
    fill="currentColor"></path>
  <path d="M171.287 95.9999H165.908V0H171.287V95.9999Z" fill="currentColor"
  ></path>
  <path d="M192.788 480H185.841V384H192.788V480Z" fill="currentColor"></path>
  <path
    d="M191.733 384.001H186.902V288.001H191.733V384.001Z"
    fill="currentColor"></path>
  <path
    d="M190.464 287.997H188.185V191.998H190.464V287.997Z"
    fill="currentColor"></path>
  <path d="M191.92 192.004H186.703V96.0038H191.92V192.004Z" fill="currentColor"
  ></path>
  <path d="M190.952 95.9999H187.703V0H190.952V95.9999Z" fill="currentColor"
  ></path>
  <path
    d="M211.843 384.001H208.244V288.001H211.843V384.001Z"
    fill="currentColor"></path>
  <path d="M213.85 287.997H206.242V191.998H213.85V287.997Z" fill="currentColor"
  ></path>
  <path
    d="M211.361 192.004H208.721V96.0038H211.361V192.004Z"
    fill="currentColor"></path>
  <path d="M211.519 95.9999H208.568V0H211.519V95.9999Z" fill="currentColor"
  ></path>
  <path d="M233.842 480H227.679V384H233.842V480Z" fill="currentColor"></path>
  <path
    d="M235.263 384.001H226.261V288.001H235.263V384.001Z"
    fill="currentColor"></path>
  <path d="M235.825 287.997H225.69V191.998H235.825V287.997Z" fill="currentColor"
  ></path>
  <path
    d="M231.885 192.004H229.619V96.0038H231.885V192.004Z"
    fill="currentColor"></path>
  <path d="M233.134 95.9999H228.39V0H233.134V95.9999Z" fill="currentColor"
  ></path>
  <path d="M254.763 480H248.202V384H254.763V480Z" fill="currentColor"></path>
  <path
    d="M253.867 384.001H249.085V288.001H253.867V384.001Z"
    fill="currentColor"></path>
  <path
    d="M253.725 192.004H249.218V96.0038H253.725V192.004Z"
    fill="currentColor"></path>
  <path d="M253.605 95.9999H249.347V0H253.605V95.9999Z" fill="currentColor"
  ></path>
  <path d="M273.488 480H270.923V384H273.488V480Z" fill="currentColor"></path>
  <path
    d="M273.982 384.001H270.409V288.001H273.982V384.001Z"
    fill="currentColor"></path>
  <path
    d="M274.855 287.997H269.538V191.998H274.855V287.997Z"
    fill="currentColor"></path>
  <path
    d="M275.429 192.004H268.967V96.0038H275.429V192.004Z"
    fill="currentColor"></path>
  <path d="M275.799 95.9999H268.59V0H275.799V95.9999Z" fill="currentColor"
  ></path>
  <path d="M293.909 480H291.942V384H293.909V480Z" fill="currentColor"></path>
  <path
    d="M296.507 384.001H289.323V288.001H296.507V384.001Z"
    fill="currentColor"></path>
  <path
    d="M295.446 287.997H290.366V191.998H295.446V287.997Z"
    fill="currentColor"></path>
  <path
    d="M293.707 192.004H292.125V96.0038H293.707V192.004Z"
    fill="currentColor"></path>
  <path d="M294.117 95.9999H291.727V0H294.117V95.9999Z" fill="currentColor"
  ></path>
  <path d="M315.634 480H311.624V384H315.634V480Z" fill="currentColor"></path>
  <path
    d="M314.701 384.001H312.559V288.001H314.701V384.001Z"
    fill="currentColor"></path>
  <path
    d="M317.373 287.997H309.902V191.998H317.373V287.997Z"
    fill="currentColor"></path>
  <path
    d="M319.837 192.004H307.423V96.0038H319.837V192.004Z"
    fill="currentColor"></path>
  <path d="M317.436 95.9999H309.84V0H317.436V95.9999Z" fill="currentColor"
  ></path>
  <path d="M336.567 480H332.147V384H336.567V480Z" fill="currentColor"></path>
  <path
    d="M336.117 384.001H332.605V288.001H336.117V384.001Z"
    fill="currentColor"></path>
  <path d="M337.85 287.997H330.865V191.998H337.85V287.997Z" fill="currentColor"
  ></path>
  <path
    d="M336.378 192.004H332.344V96.0038H336.378V192.004Z"
    fill="currentColor"></path>
  <path d="M337.433 95.9999H331.282V0H337.433V95.9999Z" fill="currentColor"
  ></path>
  <path d="M358.068 480H352.104V384H358.068V480Z" fill="currentColor"></path>
  <path
    d="M357.043 384.001H353.096V288.001H357.043V384.001Z"
    fill="currentColor"></path>
  <path
    d="M356.824 287.997H353.325V191.998H356.824V287.997Z"
    fill="currentColor"></path>
  <path
    d="M356.432 192.004H353.705V96.0038H356.432V192.004Z"
    fill="currentColor"></path>
  <path d="M358.727 95.9999H351.431V0H358.727V95.9999Z" fill="currentColor"
  ></path>
  <path d="M378.435 480H373.155V384H378.435V480Z" fill="currentColor"></path>
  <path
    d="M378.227 384.001H373.371V288.001H378.227V384.001Z"
    fill="currentColor"></path>
  <path
    d="M378.958 287.997H372.633V191.998H378.958V287.997Z"
    fill="currentColor"></path>
  <path
    d="M376.982 192.004H374.616V96.0038H376.982V192.004Z"
    fill="currentColor"></path>
  <path d="M377.92 95.9999H373.662V0H377.92V95.9999Z" fill="currentColor"
  ></path>
  <path d="M398.769 480H394.25V384H398.769V480Z" fill="currentColor"></path>
  <path
    d="M398.249 384.001H394.775V288.001H398.249V384.001Z"
    fill="currentColor"></path>
  <path d="M401.46 287.997H391.574V191.998H401.46V287.997Z" fill="currentColor"
  ></path>
  <path
    d="M400.624 192.004H392.406V96.0038H400.624V192.004Z"
    fill="currentColor"></path>
  <path d="M400.732 95.9999H392.29V0H400.732V95.9999Z" fill="currentColor"
  ></path>
  <path d="M417.541 480H416.92V384H417.541V480Z" fill="currentColor"></path>
  <path
    d="M419.561 384.001H414.904V288.001H419.561V384.001Z"
    fill="currentColor"></path>
  <path
    d="M418.785 287.997H415.672V191.998H418.785V287.997Z"
    fill="currentColor"></path>
  <path
    d="M421.203 192.004H413.247V96.0038H421.203V192.004Z"
    fill="currentColor"></path>
  <path d="M420.445 95.9999H414.021V0H420.445V95.9999Z" fill="currentColor"
  ></path>
  <path d="M439.798 480H436.125V384H439.798V480Z" fill="currentColor"></path>
  <path
    d="M439.152 384.001H436.761V288.001H439.152V384.001Z"
    fill="currentColor"></path>
  <path
    d="M440.676 287.997H435.223V191.998H440.676V287.997Z"
    fill="currentColor"></path>
  <path
    d="M438.969 192.004H436.939V96.0038H438.969V192.004Z"
    fill="currentColor"></path>
  <path d="M440.531 95.9999H435.376V0H440.531V95.9999Z" fill="currentColor"
  ></path>
  <path d="M461.775 480H455.587V384H461.775V480Z" fill="currentColor"></path>
  <path
    d="M460.848 384.001H456.503V288.001H460.848V384.001Z"
    fill="currentColor"></path>
  <path
    d="M460.501 287.997H456.853V191.998H460.501V287.997Z"
    fill="currentColor"></path>
  <path
    d="M462.329 192.004H455.021V96.0038H462.329V192.004Z"
    fill="currentColor"></path>
  <path d="M461.896 95.9999H455.446V0H461.896V95.9999Z" fill="currentColor"
  ></path>
  <path d="M483.709 480H475.08V384H483.709V480Z" fill="currentColor"></path>
  <path
    d="M484.172 384.001H474.622V288.001H484.172V384.001Z"
    fill="currentColor"></path>
  <path
    d="M482.378 287.997H476.414V191.998H482.378V287.997Z"
    fill="currentColor"></path>
  <path d="M481.52 192.004H477.287V96.0038H481.52V192.004Z" fill="currentColor"
  ></path>
  <path d="M480.322 95.9999H478.454V0H480.322V95.9999Z" fill="currentColor"
  ></path>
  <path d="M501.822 480H498.411V384H501.822V480Z" fill="currentColor"></path>
  <path d="M502.47 384.001H497.751V288.001H502.47V384.001Z" fill="currentColor"
  ></path>
  <path
    d="M502.959 287.997H497.282V191.998H502.959V287.997Z"
    fill="currentColor"></path>
  <path
    d="M501.439 192.004H498.775V96.0038H501.439V192.004Z"
    fill="currentColor"></path>
  <path d="M500.76 95.9999H499.486V0H500.76V95.9999Z" fill="currentColor"
  ></path>
  <path d="M521.732 480H519.939V384H521.732V480Z" fill="currentColor"></path>
  <path
    d="M523.763 384.001H517.899V288.001H523.763V384.001Z"
    fill="currentColor"></path>
  <path d="M521.15 287.997H520.529V191.998H521.15V287.997Z" fill="currentColor"
  ></path>
  <path
    d="M522.055 192.004H519.602V96.0038H522.055V192.004Z"
    fill="currentColor"></path>
  <path d="M524.421 95.9999H517.25V0H524.421V95.9999Z" fill="currentColor"
  ></path>
  <path d="M543.057 480H540.068V384H543.057V480Z" fill="currentColor"></path>
  <path
    d="M545.069 384.001H538.034V288.001H545.069V384.001Z"
    fill="currentColor"></path>
  <path
    d="M543.336 287.997H539.775V191.998H543.336V287.997Z"
    fill="currentColor"></path>
  <path d="M544.933 95.9999H538.185V0H544.933V95.9999Z" fill="currentColor"
  ></path>
  <path d="M566.813 480H557.748V384H566.813V480Z" fill="currentColor"></path>
  <path
    d="M564.342 384.001H560.209V288.001H564.342V384.001Z"
    fill="currentColor"></path>
  <path
    d="M564.678 287.997H559.872V191.998H564.678V287.997Z"
    fill="currentColor"></path>
  <path
    d="M564.219 192.004H560.322V96.0038H564.219V192.004Z"
    fill="currentColor"></path>
  <path d="M585.592 480H580.4V384H585.592V480Z" fill="currentColor"></path>
  <path
    d="M586.929 384.001H579.047V288.001H586.929V384.001Z"
    fill="currentColor"></path>
  <path
    d="M585.946 287.997H580.044V191.998H585.946V287.997Z"
    fill="currentColor"></path>
  <path
    d="M584.067 192.004H581.925V96.0038H584.067V192.004Z"
    fill="currentColor"></path>
  <path d="M586.294 95.9999H579.708V0H586.294V95.9999Z" fill="currentColor"
  ></path>
  <path d="M607.347 480H600.063V384H607.347V480Z" fill="currentColor"></path>
  <path
    d="M606.477 384.001H600.936V288.001H606.477V384.001Z"
    fill="currentColor"></path>
  <path
    d="M605.196 287.997H602.233V191.998H605.196V287.997Z"
    fill="currentColor"></path>
  <path d="M605.293 192.004H602.13V96.0038H605.293V192.004Z" fill="currentColor"
  ></path>
  <path d="M606.676 95.9999H600.737V0H606.676V95.9999Z" fill="currentColor"
  ></path>
  <path d="M627.244 480H621.616V384H627.244V480Z" fill="currentColor"></path>
  <path
    d="M625.402 384.001H623.472V288.001H625.402V384.001Z"
    fill="currentColor"></path>
  <path
    d="M625.798 287.997H623.071V191.998H625.798V287.997Z"
    fill="currentColor"></path>
  <path d="M626.177 95.9999H622.691V0H626.177V95.9999Z" fill="currentColor"
  ></path>
  <path d="M648.026 480H642.273V384H648.026V480Z" fill="currentColor"></path>
  <path
    d="M650.764 384.001H639.533V288.001H650.764V384.001Z"
    fill="currentColor"></path>
  <path
    d="M646.849 287.997H643.475V191.998H646.849V287.997Z"
    fill="currentColor"></path>
  <path d="M650.38 192.004H639.921V96.0038H650.38V192.004Z" fill="currentColor"
  ></path>
  <path d="M648.634 95.9999H641.662V0H648.634V95.9999Z" fill="currentColor"
  ></path>
  <path d="M669.653 480H662.096V384H669.653V480Z" fill="currentColor"></path>
  <path
    d="M668.672 384.001H663.082V288.001H668.672V384.001Z"
    fill="currentColor"></path>
  <path
    d="M668.768 287.997H662.966V191.998H668.768V287.997Z"
    fill="currentColor"></path>
  <path
    d="M667.311 192.004H664.435V96.0038H667.311V192.004Z"
    fill="currentColor"></path>
  <path d="M666.583 95.9999H665.159V0H666.583V95.9999Z" fill="currentColor"
  ></path>
  <path d="M689.227 480H683.96V384H689.227V480Z" fill="currentColor"></path>
  <path
    d="M688.104 384.001H685.079V288.001H688.104V384.001Z"
    fill="currentColor"></path>
  <path
    d="M687.026 287.997H686.178V191.998H687.026V287.997Z"
    fill="currentColor"></path>
  <path
    d="M688.183 192.004H684.995V96.0038H688.183V192.004Z"
    fill="currentColor"></path>
  <path d="M689.671 95.9999H683.508V0H689.671V95.9999Z" fill="currentColor"
  ></path>
  <path d="M710.581 480H704.044V384H710.581V480Z" fill="currentColor"></path>
  <path
    d="M709.671 384.001H704.952V288.001H709.671V384.001Z"
    fill="currentColor"></path>
  <path
    d="M711.178 287.997H703.446V191.998H711.178V287.997Z"
    fill="currentColor"></path>
  <path
    d="M708.909 192.004H705.709V96.0038H708.909V192.004Z"
    fill="currentColor"></path>
  <path d="M708.969 95.9999H705.645V0H708.969V95.9999Z" fill="currentColor"
  ></path>
  <path d="M729.311 480H726.771V384H729.311V480Z" fill="currentColor"></path>
  <path d="M729.268 384.001H726.79V288.001H729.268V384.001Z" fill="currentColor"
  ></path>
  <path
    d="M733.765 287.997H722.298V191.998H733.765V287.997Z"
    fill="currentColor"></path>
  <path
    d="M731.634 192.004H724.438V96.0038H731.634V192.004Z"
    fill="currentColor"></path>
  <path d="M729.877 95.9999H726.192V0H729.877V95.9999Z" fill="currentColor"
  ></path>
  <path d="M749.902 480H747.599V384H749.902V480Z" fill="currentColor"></path>
  <path
    d="M751.139 287.997H746.346V191.998H751.139V287.997Z"
    fill="currentColor"></path>
  <path
    d="M752.189 192.004H745.316V96.0038H752.189V192.004Z"
    fill="currentColor"></path>
  <path d="M749.962 95.9999H747.534V0H749.962V95.9999Z" fill="currentColor"
  ></path>
  <path d="M771.591 480H767.346V384H771.591V480Z" fill="currentColor"></path>
  <path
    d="M770.702 384.001H768.224V288.001H770.702V384.001Z"
    fill="currentColor"></path>
  <path
    d="M771.715 287.997H767.232V191.998H771.715V287.997Z"
    fill="currentColor"></path>
  <path
    d="M770.639 192.004H768.286V96.0038H770.639V192.004Z"
    fill="currentColor"></path>
  <path d="M772.08 95.9999H766.863V0H772.08V95.9999Z" fill="currentColor"
  ></path>
  <path d="M791.61 480H788.771V384H791.61V480Z" fill="currentColor"></path>
  <path d="M794 384.001H786.368V288.001H794V384.001Z" fill="currentColor"
  ></path>
  <path
    d="M791.763 287.997H788.626V191.998H791.763V287.997Z"
    fill="currentColor"></path>
  <path
    d="M791.488 192.004H788.898V96.0038H791.488V192.004Z"
    fill="currentColor"></path>
  <path d="M791.775 95.9999H788.612V0H791.775V95.9999Z" fill="currentColor"
  ></path>
</svg>`;

    // DNA Pattern (464x288) for image background
    const dnaPattern = `<svg class="h-full w-full" fill="currentColor" viewBox="0 0 464 288" xmlns="http://www.w3.org/2000/svg"><path d="M-159.809 0H-164.528V57.5999H-159.809V0Z"/><path d="M-160.019 57.5993H-164.302V115.199H-160.019V57.5993Z"/><path d="M-159.322 172.798H-165V230.398H-159.322V172.798Z"/><path d="M-161.662 230.4H-162.661V288H-161.662V230.4Z"/><path d="M-140.789 57.5993H-142.1V115.199H-140.789V57.5993Z"/><path d="M-140.727 115.202H-142.138V172.801H-140.727V115.202Z"/><path d="M-139.347 172.798H-143.518V230.398H-139.347V172.798Z"/><path d="M-139.836 230.4H-143.035V288H-139.836V230.4Z"/><path d="M-120.25 0H-121.197V57.5999H-120.25V0Z"/><path d="M-117.724 57.5993H-123.725V115.199H-117.724V57.5993Z"/><path d="M-117.175 115.202H-124.272V172.801H-117.175V115.202Z"/><path d="M-118.098 172.798H-123.34V230.398H-118.098V172.798Z"/><path d="M-118.324 230.4H-123.13V288H-118.324V230.4Z"/><path d="M-97.1934 0H-102.809V57.5999H-97.1934V0Z"/><path d="M-98.2995 115.202H-101.699V172.801H-98.2995V115.202Z"/><path d="M-94.444 172.798H-105.563V230.398H-94.444V172.798Z"/><path d="M-95.1494 230.4H-104.849V288H-95.1494V230.4Z"/><path d="M-76.8358 0H-81.7415V57.5999H-76.8358V0Z"/><path d="M-76.5118 57.5993H-82.0649V115.199H-76.5118V57.5993Z"/><path d="M-76.9582 115.202H-81.6149V172.801H-76.9582V115.202Z"/><path d="M-77.0056 172.798H-81.5502V230.398H-77.0056V172.798Z"/><path d="M-77.0127 230.4H-81.5448V288H-77.0127V230.4Z"/><path d="M-56.2991 0H-60.8064V57.5999H-56.2991V0Z"/><path d="M-56.1277 115.202H-61.0085V172.801H-56.1277V115.202Z"/><path d="M-57.3245 172.798H-59.8147V230.398H-57.3245V172.798Z"/><path d="M-57.3235 230.4H-59.8012V288H-57.3235V230.4Z"/><path d="M-35.6218 0H-40.0544V57.5999H-35.6218V0Z"/><path d="M-37.1256 115.202H-38.5615V172.801H-37.1256V115.202Z"/><path d="M-35.2248 172.798H-40.4667V230.398H-35.2248V172.798Z"/><path d="M-14.9456 0H-19.3159V57.5999H-14.9456V0Z"/><path d="M-13.4058 57.5993H-20.8142V115.199H-13.4058V57.5993Z"/><path d="M-13.9679 115.202H-20.2806V172.801H-13.9679V115.202Z"/><path d="M-14.6037 172.798H-19.6339V230.398H-14.6037V172.798Z"/><path d="M-12.9261 230.4H-21.3181V288H-12.9261V230.4Z"/><path d="M4.6266 0H2.55974V57.5999H4.6266V0Z"/><path d="M7.13496 57.5993H0.0752258V115.199H7.13496V57.5993Z"/><path d="M3.9052 115.202H3.28465V172.801H3.9052V115.202Z"/><path d="M3.9052 172.798H3.28465V230.398H3.9052V172.798Z"/><path d="M6.28673 230.4H0.907883V288H6.28673V230.4Z"/><path d="M27.7883 0H20.8407V57.5999H27.7883V0Z"/><path d="M26.7334 57.5993H21.9024V115.199H26.7334V57.5993Z"/><path d="M25.4636 115.202H23.1851V172.801H25.4636V115.202Z"/><path d="M26.9199 172.798H21.703V230.398H26.9199V172.798Z"/><path d="M25.9524 230.4H22.7027V288H25.9524V230.4Z"/><path d="M46.8428 57.5993H43.2445V115.199H46.8428V57.5993Z"/><path d="M48.8499 115.202H41.2423V172.801H48.8499V115.202Z"/><path d="M46.361 172.798H43.7214V230.398H46.361V172.798Z"/><path d="M46.5187 230.4H43.5678V288H46.5187V230.4Z"/><path d="M68.842 0H62.6787V57.5999H68.842V0Z"/><path d="M70.2634 57.5993H61.2613V115.199H70.2634V57.5993Z"/><path d="M70.8252 115.202H60.69V172.801H70.8252V115.202Z"/><path d="M66.885 172.798H64.6189V230.398H66.885V172.798Z"/><path d="M68.134 230.4H63.3901V288H68.134V230.4Z"/><path d="M89.7633 0H83.2016V57.5999H89.7633V0Z"/><path d="M88.8667 57.5993H84.0855V115.199H88.8667V57.5993Z"/><path d="M88.7248 172.798H84.2176V230.398H88.7248V172.798Z"/><path d="M88.6051 230.4H84.3469V288H88.6051V230.4Z"/><path d="M108.488 0H105.923V57.5999H108.488V0Z"/><path d="M108.982 57.5993H105.409V115.199H108.982V57.5993Z"/><path d="M109.855 115.202H104.538V172.801H109.855V115.202Z"/><path d="M110.429 172.798H103.967V230.398H110.429V172.798Z"/><path d="M110.799 230.4H103.59V288H110.799V230.4Z"/><path d="M128.909 0H126.942V57.5999H128.909V0Z"/><path d="M131.507 57.5993H124.323V115.199H131.507V57.5993Z"/><path d="M130.446 115.202H125.366V172.801H130.446V115.202Z"/><path d="M128.707 172.798H127.125V230.398H128.707V172.798Z"/><path d="M129.117 230.4H126.727V288H129.117V230.4Z"/><path d="M150.634 0H146.624V57.5999H150.634V0Z"/><path d="M149.701 57.5993H147.559V115.199H149.701V57.5993Z"/><path d="M152.373 115.202H144.902V172.801H152.373V115.202Z"/><path d="M154.837 172.798H142.423V230.398H154.837V172.798Z"/><path d="M152.436 230.4H144.84V288H152.436V230.4Z"/><path d="M171.567 0H167.147V57.5999H171.567V0Z"/><path d="M171.117 57.5993H167.605V115.199H171.117V57.5993Z"/><path d="M172.85 115.202H165.865V172.801H172.85V115.202Z"/><path d="M171.378 172.798H167.344V230.398H171.378V172.798Z"/><path d="M172.433 230.4H166.282V288H172.433V230.4Z"/><path d="M193.068 0H187.104V57.5999H193.068V0Z"/><path d="M192.043 57.5993H188.096V115.199H192.043V57.5993Z"/><path d="M191.824 115.202H188.325V172.801H191.824V115.202Z"/><path d="M191.432 172.798H188.705V230.398H191.432V172.798Z"/><path d="M193.727 230.4H186.431V288H193.727V230.4Z"/><path d="M213.435 0H208.155V57.5999H213.435V0Z"/><path d="M213.227 57.5993H208.371V115.199H213.227V57.5993Z"/><path d="M213.958 115.202H207.633V172.801H213.958V115.202Z"/><path d="M211.982 172.798H209.616V230.398H211.982V172.798Z"/><path d="M212.92 230.4H208.662V288H212.92V230.4Z"/><path d="M233.769 0H229.25V57.5999H233.769V0Z"/><path d="M233.249 57.5993H229.775V115.199H233.249V57.5993Z"/><path d="M236.46 115.202H226.574V172.801H236.46V115.202Z"/><path d="M235.624 172.798H227.406V230.398H235.624V172.798Z"/><path d="M235.732 230.4H227.29V288H235.732V230.4Z"/><path d="M252.541 0H251.92V57.5999H252.541V0Z"/><path d="M254.561 57.5993H249.904V115.199H254.561V57.5993Z"/><path d="M253.785 115.202H250.672V172.801H253.785V115.202Z"/><path d="M256.203 172.798H248.247V230.398H256.203V172.798Z"/><path d="M255.445 230.4H249.021V288H255.445V230.4Z"/><path d="M274.798 0H271.125V57.5999H274.798V0Z"/><path d="M274.152 57.5993H271.761V115.199H274.152V57.5993Z"/><path d="M275.676 115.202H270.223V172.801H275.676V115.202Z"/><path d="M273.969 172.798H271.939V230.398H273.969V172.798Z"/><path d="M275.531 230.4H270.376V288H275.531V230.4Z"/><path d="M296.775 0H290.587V57.5999H296.775V0Z"/><path d="M295.848 57.5993H291.503V115.199H295.848V57.5993Z"/><path d="M295.501 115.202H291.853V172.801H295.501V115.202Z"/><path d="M297.329 172.798H290.021V230.398H297.329V172.798Z"/><path d="M296.896 230.4H290.446V288H296.896V230.4Z"/><path d="M318.709 0H310.08V57.5999H318.709V0Z"/><path d="M319.172 57.5993H309.622V115.199H319.172V57.5993Z"/><path d="M317.378 115.202H311.414V172.801H317.378V115.202Z"/><path d="M316.52 172.798H312.287V230.398H316.52V172.798Z"/><path d="M315.322 230.4H313.454V288H315.322V230.4Z"/><path d="M336.822 0H333.411V57.5999H336.822V0Z"/><path d="M337.47 57.5993H332.751V115.199H337.47V57.5993Z"/><path d="M337.959 115.202H332.282V172.801H337.959V115.202Z"/><path d="M336.439 172.798H333.775V230.398H336.439V172.798Z"/><path d="M335.76 230.4H334.486V288H335.76V230.4Z"/><path d="M356.732 0H354.939V57.5999H356.732V0Z"/><path d="M358.763 57.5993H352.899V115.199H358.763V57.5993Z"/><path d="M356.15 115.202H355.529V172.801H356.15V115.202Z"/><path d="M357.055 172.798H354.602V230.398H357.055V172.798Z"/><path d="M359.421 230.4H352.25V288H359.421V230.4Z"/><path d="M378.057 0H375.068V57.5999H378.057V0Z"/><path d="M380.069 57.5993H373.034V115.199H380.069V57.5993Z"/><path d="M378.336 115.202H374.775V172.801H378.336V115.202Z"/><path d="M379.933 230.4H373.185V288H379.933V230.4Z"/><path d="M401.813 0H392.748V57.5999H401.813V0Z"/><path d="M399.342 57.5993H395.209V115.199H399.342V57.5993Z"/><path d="M399.678 115.202H394.872V172.801H399.678V115.202Z"/><path d="M399.219 172.798H395.322V230.398H399.219V172.798Z"/><path d="M420.592 0H415.4V57.5999H420.592V0Z"/><path d="M421.929 57.5993H414.047V115.199H421.929V57.5993Z"/><path d="M420.946 115.202H415.044V172.801H420.946V115.202Z"/><path d="M419.067 172.798H416.925V230.398H419.067V172.798Z"/><path d="M421.294 230.4H414.708V288H421.294V230.4Z"/><path d="M442.347 0H435.063V57.5999H442.347V0Z"/><path d="M441.477 57.5993H435.936V115.199H441.477V57.5993Z"/><path d="M440.196 115.202H437.233V172.801H440.196V115.202Z"/><path d="M440.293 172.798H437.13V230.398H440.293V172.798Z"/><path d="M441.676 230.4H435.737V288H441.676V230.4Z"/><path d="M462.244 0H456.616V57.5999H462.244V0Z"/><path d="M460.402 57.5993H458.472V115.199H460.402V57.5993Z"/><path d="M460.798 115.202H458.071V172.801H460.798V115.202Z"/><path d="M461.177 230.4H457.691V288H461.177V230.4Z"/><path d="M483.026 0H477.273V57.5999H483.026V0Z"/><path d="M485.764 57.5993H474.533V115.199H485.764V57.5993Z"/><path d="M481.849 115.202H478.475V172.801H481.849V115.202Z"/><path d="M485.38 172.798H474.921V230.398H485.38V172.798Z"/><path d="M483.634 230.4H476.662V288H483.634V230.4Z"/><path d="M504.653 0H497.096V57.5999H504.653V0Z"/><path d="M503.672 57.5993H498.082V115.199H503.672V57.5993Z"/><path d="M503.768 115.202H497.966V172.801H503.768V115.202Z"/><path d="M502.311 172.798H499.435V230.398H502.311V172.798Z"/><path d="M501.583 230.4H500.159V288H501.583V230.4Z"/><path d="M524.227 0H518.96V57.5999H524.227V0Z"/><path d="M523.104 57.5993H520.079V115.199H523.104V57.5993Z"/><path d="M522.026 115.202H521.178V172.801H522.026V115.202Z"/><path d="M523.183 172.798H519.995V230.398H523.183V172.798Z"/><path d="M524.671 230.4H518.508V288H524.671V230.4Z"/><path d="M545.581 0H539.044V57.5999H545.581V0Z"/><path d="M544.671 57.5993H539.952V115.199H544.671V57.5993Z"/><path d="M546.178 115.202H538.446V172.801H546.178V115.202Z"/><path d="M543.909 172.798H540.709V230.398H543.909V172.798Z"/><path d="M543.969 230.4H540.645V288H543.969V230.4Z"/><path d="M564.311 0H561.771V57.5999H564.311V0Z"/><path d="M564.268 57.5993H561.79V115.199H564.268V57.5993Z"/><path d="M568.765 115.202H557.298V172.801H568.765V115.202Z"/><path d="M566.634 172.798H559.438V230.398H566.634V172.798Z"/><path d="M564.877 230.4H561.192V288H564.877V230.4Z"/><path d="M584.902 0H582.599V57.5999H584.902V0Z"/><path d="M586.139 115.202H581.346V172.801H586.139V115.202Z"/><path d="M587.189 172.798H580.316V230.398H587.189V172.798Z"/><path d="M584.962 230.4H582.534V288H584.962V230.4Z"/><path d="M606.591 0H602.346V57.5999H606.591V0Z"/><path d="M605.702 57.5993H603.224V115.199H605.702V57.5993Z"/><path d="M606.715 115.202H602.232V172.801H606.715V115.202Z"/><path d="M605.639 172.798H603.286V230.398H605.639V172.798Z"/><path d="M607.08 230.4H601.863V288H607.08V230.4Z"/><path d="M626.61 0H623.771V57.5999H626.61V0Z"/><path d="M629 57.5993H621.368V115.199H629V57.5993Z"/><path d="M626.763 115.202H623.626V172.801H626.763V115.202Z"/><path d="M626.488 172.798H623.898V230.398H626.488V172.798Z"/><path d="M626.775 230.4H623.612V288H626.775V230.4Z"/></svg>`;

    // Modal HTML template
    function createModalHTML(data) {
        return `
<div id="team-modal-backdrop" class="member-modal-backdrop pointer-events-none fixed inset-0 bg-black/60 opacity-0 transition-opacity duration-300" style="z-index: 9998;" data-modal-backdrop></div>
<div id="team-modal-panel" class="member-modal pointer-events-none fixed bottom-0 right-0 h-[calc(100%-24px)] w-full transition-transform duration-300 ease-out md:bottom-auto md:top-0 md:h-full md:max-w-[670px] md:ps-l lg:max-w-[794px]" style="z-index: 9999;" data-modal role="dialog" aria-modal="true">
    <div class="member-modal-inner relative h-full w-full overflow-hidden bg-surface-darker md:border-b-4 md:border-brand">
        <div class="modal-dna-pattern pointer-events-none absolute right-0 top-0 h-[240px] md:h-[480px] w-[794px] -scale-y-100 opacity-60" style="color: #211A19; background: linear-gradient(0, #262121 -2.94%, #211918 100%); -webkit-mask-image: linear-gradient(0, black 0%, black 40%, transparent 100%); mask-image: linear-gradient(0, black 0%, black 40%, transparent 100%);">${dnaPatternV2}</div>
        <button type="button" id="team-modal-close" class="absolute right-0 top-0 z-10 p-2xs text-inverse-default transition-colors duration-200 hover:text-white md:right-s md:top-s" aria-label="Close modal">${closeIcon}</button>
        <div class="member-modal-scroll-mobile h-full overflow-y-auto md:h-full md:overflow-hidden">
            <div class="flex flex-col gap-m p-m md:h-full md:p-curve-l">
                <div class="member-img-corner-cut relative aspect-[16/10] w-full shrink-0 overflow-hidden bg-surface-darker">
                    <div class="absolute inset-0 bg-gradient-to-b from-[#e5e1de] from-0% via-[#c3bcb4] via-40% to-[#c3bcb4]"></div>
                    <div class="member-dna-pattern pointer-events-none absolute bottom-0 left-1/2 h-full w-[794px] -translate-x-1/2 opacity-50">${dnaPattern}</div>
                                        ${data.imageUrl ? `<div class="absolute inset-0 bg-cover bg-top bg-no-repeat" style="background-image: url(${data.imageUrl});"></div>` : ""}
                </div>
                <div class="member-modal-content md:min-h-0 md:flex-1 md:overflow-y-auto">
                    <div class="flex flex-col gap-s">
                        <div class="flex flex-col gap-2xs">
                            <div class="flex items-center gap-2xs">${bbSymbolSmall}<span class="font-sans text-subheading-sm font-bold uppercase text-inverse-default">${data.position}</span></div>
                            <h2 class="m-0 font-sans text-heading-h3 font-normal text-inverse-strong">${data.name}</h2>
                        </div>
                        <div class="flex flex-col gap-s"><p class="m-0 font-sans text-paragraph-md text-inverse-strong whitespace-pre-line">${data.bio}</p></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>`;
    }

    let currentModal = null;

    function initSwipeToDismiss(panel, backdrop) {
        // Only enable on mobile (< 768px)
        if (window.innerWidth >= 768) return;

        let startY = 0;
        let currentY = 0;
        let isDragging = false;

        panel.addEventListener(
            "touchstart",
            (e) => {
                // Only track from the top area (drag handle) or when scrolled to top
                const scrollContainer = panel.querySelector(".member-modal-scroll-mobile");
                if (scrollContainer && scrollContainer.scrollTop > 0) return;

                startY = e.touches[0].clientY;
                currentY = startY;
                isDragging = true;
                panel.style.transition = "none";
                backdrop.style.transition = "none";
            },
            { passive: true },
        );

        panel.addEventListener(
            "touchmove",
            (e) => {
                if (!isDragging) return;

                currentY = e.touches[0].clientY;
                const deltaY = currentY - startY;

                // Only allow downward drag
                if (deltaY <= 0) {
                    panel.style.transform = "";
                    backdrop.style.opacity = "";
                    return;
                }

                panel.style.transform = `translateY(${deltaY}px)`;
                // Fade backdrop as user drags
                const progress = Math.min(deltaY / 300, 1);
                backdrop.style.opacity = `${1 - progress}`;
            },
            { passive: true },
        );

        panel.addEventListener(
            "touchend",
            () => {
                if (!isDragging) return;
                isDragging = false;

                const deltaY = currentY - startY;
                panel.style.transition = "";
                backdrop.style.transition = "";

                panel.style.transform = "";
                backdrop.style.opacity = "";

                // Close if swiped down more than 100px
                if (deltaY > 100) closeModal();
            },
            { passive: true },
        );
    }

    function openModal(data) {
        if (currentModal) closeModal();

        const container = document.createElement("div");
        container.id = "team-modal-container";
        container.innerHTML = createModalHTML(data);
        document.body.appendChild(container);
        currentModal = container;

        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        document.body.style.paddingRight = scrollbarWidth + "px";

        const backdrop = container.querySelector("#team-modal-backdrop");
        const panel = container.querySelector("#team-modal-panel");
        const closeBtn = container.querySelector("#team-modal-close");

        requestAnimationFrame(() => {
            backdrop.classList.remove("opacity-0", "pointer-events-none");
            backdrop.classList.add("opacity-100", "pointer-events-auto");
            panel.classList.add("is-open");
            panel.classList.remove("pointer-events-none");
            panel.classList.add("pointer-events-auto");
        });

        closeBtn.addEventListener("click", closeModal);
        backdrop.addEventListener("click", closeModal);
        document.addEventListener("keydown", handleEscape);

        // Swipe-down to close on mobile
        initSwipeToDismiss(panel, backdrop);
    }

    function closeModal() {
        if (!currentModal) return;

        const backdrop = currentModal.querySelector("#team-modal-backdrop");
        const panel = currentModal.querySelector("#team-modal-panel");

        backdrop.classList.add("opacity-0", "pointer-events-none");
        backdrop.classList.remove("opacity-100", "pointer-events-auto");
        panel.classList.remove("is-open");
        panel.classList.add("pointer-events-none");
        panel.classList.remove("pointer-events-auto");

        const scrollContent = panel.querySelector(".member-modal-content");
        const mobileScroll = panel.querySelector(".member-modal-scroll-mobile");
        if (scrollContent) scrollContent.scrollTop = 0;
        if (mobileScroll) mobileScroll.scrollTop = 0;

        setTimeout(() => {
            if (currentModal) {
                currentModal.remove();
                currentModal = null;
            }
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
            document.body.style.paddingRight = "";
        }, 300);

        document.removeEventListener("keydown", handleEscape);
    }

    function handleEscape(e) {
        if (e.key === "Escape") closeModal();
    }

    function initTeamModals() {
        document.querySelectorAll(".team-member-card").forEach((card) => {
            if (card.dataset.teamModalInit) return;
            card.dataset.teamModalInit = "true";

            card.addEventListener("click", (e) => {
                e.preventDefault();

                const imgEl = card.querySelector("img");
                const positionEl = card.querySelector(".text-subheading-sm");
                const nameEl = card.querySelector(".text-subheading-lg");
                const bioEl = card.querySelector(".line-clamp-3");

                const wrapper = card.closest("[data-__neos-node-contextpath]") || card.parentElement;
                const fullBioEl = wrapper?.querySelector("[data-full-bio]");

                openModal({
                    imageUrl: imgEl?.src || "",
                    position: positionEl?.textContent?.trim() || "",
                    name: nameEl?.textContent?.trim() || "",
                    bio: fullBioEl?.textContent?.trim() || bioEl?.textContent?.trim() || "",
                });
            });
        });
    }

    // Viewport animation for section (header, description, button)
    function initSectionAnimation() {
        const sections = document.querySelectorAll(".team-section");
        if (!sections.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 },
        );

        sections.forEach((section) => observer.observe(section));
    }

    // Viewport animation for individual cards with stagger
    function initCardAnimation() {
        const cards = document.querySelectorAll(".team-member-card");
        if (!cards.length) return;

        // Wait for initial styles to be applied
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                // Get card index within its section for stagger
                                const card = entry.target;
                                const section = card.closest(".team-section");
                                const sectionCards = section ? section.querySelectorAll(".team-member-card") : [card];
                                const index = Array.from(sectionCards).indexOf(card);

                                // Base delay 100ms + stagger 80ms per card
                                setTimeout(
                                    () => {
                                        card.classList.add("is-visible");
                                    },
                                    100 + index * 80,
                                );

                                observer.unobserve(card);
                            }
                        });
                    },
                    { threshold: 0.2 },
                );

                cards.forEach((card) => observer.observe(card));
            });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
            initTeamModals();
            initSectionAnimation();
            initCardAnimation();
        });
    } else {
        initTeamModals();
        initSectionAnimation();
        initCardAnimation();
    }
})();
